import React, { Component } from 'react';
import propTypes from 'prop-types';
import { connect } from 'react-redux';

import Panel from '../Panel/Panel';
// import Standard from '../Standard/Standard';
// import Header from '../Header/Header';
// import TextDisplay from '../TextDisplay/TextDisplay';

import './SplitPanel.css';

class SplitPanel extends Component {
  render() {
    let props = this.props;
    return (
      <section className={`split-panel-container ${props.data.fullscreen ? 'fullscreen' : ''} ${props.data.style}`}>
        <section className={`split-panel split-panel__lhs ${props.data.style ? props.data.style : ''}`} style={{'backgroundImage': 'url("' + (props.data.image && props.data.image.src) + '")'}}>
          <Panel panel={props.data.panel} />
        </section>
        <section className={`split-panel split-panel__rhs ${props.data.style ? props.data.style : ''}`} style={{'backgroundImage': 'url("' + (props.data.altImage && props.data.altImage.src) + '")'}}>
          <Panel panel={props.data.altPanel} />
        </section>
      </section>
    )
  }
}


// function mapDispatchToProps(dispatch) {
//   return {
//     goToSection: (sectionID) => {
//       dispatch(actions.goToSection(sectionID));
//     },
//     goToGroup: (groupID) => {
//       dispatch(actions.goToGroup(groupID));
//     },
//   };
// }

SplitPanel.propTypes = {
  data: propTypes.shape({
    panel: propTypes.number,
    altPanel: propTypes.number,
    image: propTypes.object,
    altImage: propTypes.object,
    fullscreen: propTypes.bool,
    style: propTypes.string,
  }),
};

export default connect(null, null)(SplitPanel);


// WEBPACK FOOTER //
// ./src/components/SplitPanel/SplitPanel.js